import React, { useEffect, useState, useMemo, useContext } from 'react';
import { Scatter } from 'react-chartjs-2';
import LoadingTable from '../LoadingTable';
import Axios, { all } from "axios";
import { thai_date, checkGroupsUser, getlocalStorage, handleResizeDisplay } from '../../function/functionALL';
import "../../components/style.css";
import { YearContext } from '../usecontext/YearContext';
import Swal from "sweetalert2";
import BloodPressure from "../../img/BloodPressure.png"

const BloodPressureChartComponent = ({ showChartBloodPressure, unitname, all_round }) => {
    const [bloodPressureData1, setbloodPressureData1] = useState([]);
    const [bloodPressureData2, setbloodPressureData2] = useState([]);
    const [bloodPressureDatasummary1, setbloodPressureDatasummary1] = useState([]);
    const [bloodPressureDatasummary2, setbloodPressureDatasummary2] = useState([]);
    const [loading, setLoading] = useState(true);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole
    const [chartReady, setChartReady] = useState(false);
    const DateTime = new Date()
    const { yearcurrent } = useContext(YearContext);
    const [isStacked, setIsStacked] = useState(false);



    useEffect(() => {
        handleResizeDisplay(setIsStacked);

        if (unitname === undefined) {
            GetbloodPressureData1();
            GetbloodPressureData2();
            GetbloodPressureData1_summary1()
            GetbloodPressureData2_summary2()
        }
        else {
            GetbloodPressureData1unit();
            GetbloodPressureData2unit();
            GetbloodPressureData1Unit_summary1()
            GetbloodPressureData2Unit_summary2()

        }
    }, [yearcurrent, unitname]);



    // useEffect(() => {
    //     if (bloodPressureData1.length > 0) {

    //         setChartReady(true);
    //     }
    // }, [bloodPressureData1]);
    // useEffect(() => {
    //     if (bloodPressureData2.length > 0) {

    //         setChartReady(true);
    //     }
    // }, [bloodPressureData2]);

    const GetbloodPressureData1 = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_data/?year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log("allData", allData)

            if (allData === undefined) {
                setbloodPressureData1([]);
            } else {
                setbloodPressureData1(allData)
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetbloodPressureData2 = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_data/?year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log("allData", allData)
            // setbloodPressureData2(allData)
            if (allData === undefined) {
                setbloodPressureData2([]);
            } else {
                setbloodPressureData2(allData)
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetbloodPressureData1unit = async () => {
        try {


            setLoading(true)
            const selectedRound = all_round.find((roundData) => roundData.round === 1);
            if (selectedRound === undefined) {
                setbloodPressureData1([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${selectedRound.id}/tester_data/`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allData", allData)
                setbloodPressureData1(allData)
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetbloodPressureData2unit = async () => {
        try {
            setLoading(true)
            const selectedRound = all_round.find((roundData) => roundData.round === 2);
            if (selectedRound === undefined) {
                setbloodPressureData2([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${selectedRound.id}/tester_data/`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allData", allData)
                setbloodPressureData2(allData)
            }
            setLoading(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetbloodPressureData1_summary1 = async () => {
        try {
            setLoading(true)

            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data/?year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            if (allData === undefined) {
                setbloodPressureDatasummary1([]);

            } else {
                setbloodPressureDatasummary1(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetbloodPressureData2_summary2 = async () => {
        try {
            setLoading(true)

            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data/?year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });

            let allData = response.data;
            if (allData === undefined) {
                setbloodPressureDatasummary2([]);

            } else {
                setbloodPressureDatasummary2(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetbloodPressureData1Unit_summary1 = async () => {
        try {
            setLoading(true)

            const selectedRound = all_round.find((roundData) => roundData.round === 1);
            // console.log("selectedRound", selectedRound.id)

            if (selectedRound === undefined) {
                setbloodPressureDatasummary1([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data?test_round_id=${selectedRound.id}`, {
                    
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                

                setbloodPressureDatasummary1(allData);
            }
            setLoading(false);


        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetbloodPressureData2Unit_summary2 = async () => {
        try {

            const selectedRound = all_round.find((roundData) => roundData.round === 2);
            // console.log("selectedRound", selectedRound)
            if (selectedRound === undefined) {
                setbloodPressureDatasummary2([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data?test_round_id=${selectedRound.id}`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allDataBMI2unit", allData)

                setbloodPressureDatasummary2(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };


    const bloodPressureData_1 = useMemo(() => {
        return Array.isArray(bloodPressureData1) ? bloodPressureData1.map(item => {
            const blood_pressure_upper = parseInt(item.body_data.blood_pressure_upper);
            const blood_pressure_lower = parseInt(item.body_data.blood_pressure_lower);
            return { x: blood_pressure_lower, y: blood_pressure_upper };
        }) : [];
    }, [bloodPressureData1]);
    const bloodPressureData_2 = useMemo(() => {
        return Array.isArray(bloodPressureData2) ? bloodPressureData2.map(item => {
            const blood_pressure_upper = parseInt(item.body_data.blood_pressure_upper);
            const blood_pressure_lower = parseInt(item.body_data.blood_pressure_lower);
            return { x: blood_pressure_lower, y: blood_pressure_upper };
        }) : [];
    }, [bloodPressureData2]);

    const backgroundColors = {
        LOW: 'rgba(206, 222, 239, 1)',
        NORMAL: 'rgba(145,196,161,255)',
        PREHYPERTENSION: 'rgba(250,214,73,255)',
        HIGH_STAGE_1: 'rgba(230,150,95,255)',
        HIGH_STAGE_2: 'rgba(213,92,92,255)',
    };
    const ranges = [
        { label: 'LOW', maxX: 60, maxY: 90, color: backgroundColors.LOW },
        { label: 'NORMAL', maxX: 80, maxY: 120, color: backgroundColors.NORMAL },
        { label: 'PREHYPERTENSION', maxX: 89, maxY: 139, color: backgroundColors.PREHYPERTENSION },
        { label: 'HIGH: STAGE 1', maxX: 99, maxY: 159, color: backgroundColors.HIGH_STAGE_1 },
        { label: 'HIGH: STAGE 2', maxX: 190, maxY: 255, color: backgroundColors.HIGH_STAGE_2 }
    ];
    const data_Blood_Pressure1 = {
        datasets: [
            {
                label: '',
                data: bloodPressureData_1.length > 0 ? bloodPressureData_1.map(item => ({ x: item.x, y: item.y })) : [{ x: 0, y: 0 }],
                pointHoverRadius: 7,
                hidden: false,
                showLine: false,
                pointStyle: 'rectRot',
                // backgroundColor: 'red',
                pointBackgroundColor: function (context) {

                    if (!context.raw || context.raw.x === undefined || context.raw.y === undefined) {
                        return 'transparent';
                    }
                    const systolic = context.raw.y;
                    const diastolic = context.raw.x;

                    if (systolic < 90 && diastolic < 60) return 'rgba(173, 216, 230, 1)';  // ฟ้าอ่อน (LOW)
                    if (systolic < 120 && diastolic < 80) return 'rgba(144, 238, 144, 1)'; // เขียวอ่อน (NORMAL)
                    if (systolic < 139 && diastolic < 89) return 'rgba(255, 255, 0, 1)';   // เหลือง (PREHYPERTENSION)
                    if (systolic < 159 && diastolic < 99) return 'rgba(255, 165, 0, 1)';   // ส้ม (HIGH STAGE 1)
                    return 'rgba(255, 69, 0, 1)';  // แดง (HIGH STAGE 2)
                },
            },
            ...ranges.map(range => ({
                label: range.label,
                type: 'line',
                data: [{ x: 0, y: range.maxY }, { x: range.maxX, y: range.maxY }, { x: range.maxX, y: 0 }],
                borderColor: 'white',
                backgroundColor: range.color,
                borderWidth: 2,
                fill: true,
                pointRadius: 0,
            }))
        ],
    };

    const options_Blood_Pressure1 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    filter: function (legendItem, chartData) {

                        return legendItem.text !== '';
                    }
                }

            },
            tooltip: {
                enabled: false
            }, title: {
                display: true,
                text: 'ครั้งที่ 1',
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Diastolic (mmHg)',//ล่าง
                },

                type: 'linear',
                position: 'bottom',

                min: 40,
                max: 190,
            },
            y: {
                title: {
                    display: true,
                    text: 'Systolic (mmHg)',//บน
                },
                min: 40,
                max: 255,

            },


        },



    };

    const data_Blood_Pressure2 = {
        datasets: [
            {
                label: '',
                data: bloodPressureData_2.length > 0 ? bloodPressureData_2.map(item => ({ x: item.x, y: item.y })) : [{ x: 0, y: 0 }],
                pointHoverRadius: 7,
                hidden: false,
                showLine: false,
                pointStyle: 'rectRot',
                // backgroundColor: 'red',
                pointBackgroundColor: function (context) {

                    if (!context.raw || context.raw.x === undefined || context.raw.y === undefined) {
                        return 'transparent';
                    }
                    const systolic = context.raw.y;
                    const diastolic = context.raw.x;

                    if (systolic < 90 && diastolic < 60) return 'rgba(173, 216, 230, 1)';  // ฟ้าอ่อน (LOW)
                    if (systolic < 120 && diastolic < 80) return 'rgba(144, 238, 144, 1)'; // เขียวอ่อน (NORMAL)
                    if (systolic < 139 && diastolic < 89) return 'rgba(255, 255, 0, 1)';   // เหลือง (PREHYPERTENSION)
                    if (systolic < 159 && diastolic < 99) return 'rgba(255, 165, 0, 1)';   // ส้ม (HIGH STAGE 1)
                    return 'rgba(255, 69, 0, 1)';  // แดง (HIGH STAGE 2)
                },
            },
            ...ranges.map(range => ({
                label: range.label,
                type: 'line',
                data: [{ x: 0, y: range.maxY }, { x: range.maxX, y: range.maxY }, { x: range.maxX, y: 0 }],
                borderColor: 'white',
                backgroundColor: range.color,
                borderWidth: 2,
                fill: true,
                pointRadius: 0,
            }))
        ],
    };

    const options_Blood_Pressure2 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {

            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    filter: function (legendItem, chartData) {

                        return legendItem.text !== '';
                    }
                }

            },
            tooltip: {
                enabled: false
            }, title: {
                display: true,
                text: 'ครั้งที่ 2',
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Diastolic (mmHg)',//ล่าง
                },

                type: 'linear',
                position: 'bottom',

                min: 40,
                max: 190,
            },
            y: {
                title: {
                    display: true,
                    text: 'Systolic (mmHg)',//บน
                },
                min: 40,
                max: 255,

            },


        },



    };

    return (

        <div className="col-12 m-0 p-0 pt-2 ">
            <div className="card ">
                <div className="card-body col-12 pt-3">
                    {loading ? (
                        <LoadingTable />
                    ) :
                        // chartReady ? (
                        <div>
                            <h5 className="card-title fw-bold text-start">ความดันโลหิต<span>|  ณ {thai_date(DateTime, "shortdate")}</span></h5>
                            <div className="d-flex row" >
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">

                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bloodPressureData1.length === 0 ? (<h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 1 </h5>
                                            ) : (
                                                <><Scatter options={options_Blood_Pressure1} data={data_Blood_Pressure1} style={{ height: '100%', width: '100%' }} />
                                                </>
                                            )}

                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: isStacked ? "400px" : "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bloodPressureData1.length === 0 ? (
                                                <h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 1 </h5>
                                            ) : (

                                                <div className='col-12 '>
                                                    <p style={{ fontWeight: "bold", fontSize: "14px" }}> ครั้งที่ 1</p>
                                                    <div className="col-12  d-flex justify-content-center ">
                                                        <img src={BloodPressure} className="rounded img-fluid " style={{ maxHeight: "200px", width: "70%" }} />
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center p-0 ">

                                                        <table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover'} style={{ width: "65%" }}>
                                                            <thead >
                                                                <tr style={{ verticalAlign: "middle" }}>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(206, 222, 239, 1)" }}>Low</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(145, 196, 161, 1)" }}>NORMAL</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(250, 214, 73, 1)" }}>PREHYPERTENSION</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "18%", minWidth: "20px", backgroundColor: "rgba(230, 150, 95, 1)" }}>HIGH STAGE 1</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "18%", minWidth: "20px", backgroundColor: "rgba(213, 92, 92, 1)" }}>HIGH STAGE 2</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr className="raw " >
                                                                    <td className="text-center " data-label="Low" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(206, 222, 239, 1)" }} >
                                                                        {bloodPressureDatasummary1.bp1} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary1.bp1 /
                                                                                    (bloodPressureDatasummary1.bp1 +
                                                                                        bloodPressureDatasummary1.bp2 +
                                                                                        bloodPressureDatasummary1.bp3 +
                                                                                        bloodPressureDatasummary1.bp4 +
                                                                                        bloodPressureDatasummary1.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="NORMAL" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(145, 196, 161, 1)" }}>
                                                                        {bloodPressureDatasummary1.bp2} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary1.bp2 /
                                                                                    (bloodPressureDatasummary1.bp1 +
                                                                                        bloodPressureDatasummary1.bp2 +
                                                                                        bloodPressureDatasummary1.bp3 +
                                                                                        bloodPressureDatasummary1.bp4 +
                                                                                        bloodPressureDatasummary1.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="PREHYPERTENSION" style={{ fontSize: "10px", verticalAlign: "middle", backgroundColor: "rgba(250, 214, 73, 1)" }}>
                                                                        {bloodPressureDatasummary1.bp3} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary1.bp3 /
                                                                                    (bloodPressureDatasummary1.bp1 +
                                                                                        bloodPressureDatasummary1.bp2 +
                                                                                        bloodPressureDatasummary1.bp3 +
                                                                                        bloodPressureDatasummary1.bp4 +
                                                                                        bloodPressureDatasummary1.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="HIGH STAGE 1" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(230, 150, 95, 1)" }}>
                                                                        {bloodPressureDatasummary1.bp4} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary1.bp4 /
                                                                                    (bloodPressureDatasummary1.bp1 +
                                                                                        bloodPressureDatasummary1.bp2 +
                                                                                        bloodPressureDatasummary1.bp3 +
                                                                                        bloodPressureDatasummary1.bp4 +
                                                                                        bloodPressureDatasummary1.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="HIGH STAGE 2" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(213, 92, 92, 1)" }}>
                                                                        {bloodPressureDatasummary1.bp5} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary1.bp5 /
                                                                                    (bloodPressureDatasummary1.bp1 +
                                                                                        bloodPressureDatasummary1.bp2 +
                                                                                        bloodPressureDatasummary1.bp3 +
                                                                                        bloodPressureDatasummary1.bp4 +
                                                                                        bloodPressureDatasummary1.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table> </div>

                                                </div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">

                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>
                                            {bloodPressureData2.length === 0 ? (<h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 2 </h5>
                                            ) : (
                                                <><Scatter options={options_Blood_Pressure2} data={data_Blood_Pressure2} style={{ height: '100%', width: '100%' }} />
                                                </>
                                            )}


                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: isStacked ? "400px" : "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bloodPressureData2.length === 0 ? (
                                                <h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 2 </h5>
                                            ) : (

                                                <div className='col-12 '>
                                                    <p style={{ fontWeight: "bold", fontSize: "14px" }}> ครั้งที่ 2</p>
                                                    <div className="col-12  d-flex justify-content-center ">
                                                        <img src={BloodPressure} className="rounded img-fluid " style={{ maxHeight: "200px", width: "70%" }} />
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center p-0 ">

                                                        <table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover'} style={{ width: "65%" }}>
                                                            <thead >
                                                                <tr style={{ verticalAlign: "middle" }}>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(206, 222, 239, 1)" }}>Low</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(145, 196, 161, 1)" }}>NORMAL</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(250, 214, 73, 1)" }}>PREHYPERTENSION</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "18%", minWidth: "20px", backgroundColor: "rgba(230, 150, 95, 1)" }}>HIGH STAGE 1</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "18%", minWidth: "20px", backgroundColor: "rgba(213, 92, 92, 1)" }}>HIGH STAGE 2</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr className="raw " >
                                                                    <td className="text-center " data-label="Low" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(206, 222, 239, 1)" }} >
                                                                        {bloodPressureDatasummary2.bp1} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary2.bp1 /
                                                                                    (bloodPressureDatasummary2.bp1 +
                                                                                        bloodPressureDatasummary2.bp2 +
                                                                                        bloodPressureDatasummary2.bp3 +
                                                                                        bloodPressureDatasummary2.bp4 +
                                                                                        bloodPressureDatasummary2.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="NORMAL" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(145, 196, 161, 1)" }}>
                                                                        {bloodPressureDatasummary2.bp2} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary2.bp2 /
                                                                                    (bloodPressureDatasummary2.bp1 +
                                                                                        bloodPressureDatasummary2.bp2 +
                                                                                        bloodPressureDatasummary2.bp3 +
                                                                                        bloodPressureDatasummary2.bp4 +
                                                                                        bloodPressureDatasummary2.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="PREHYPERTENSION" style={{ fontSize: "10px", verticalAlign: "middle", backgroundColor: "rgba(250, 214, 73, 1)" }}>
                                                                        {bloodPressureDatasummary2.bp3} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary2.bp3 /
                                                                                    (bloodPressureDatasummary2.bp1 +
                                                                                        bloodPressureDatasummary2.bp2 +
                                                                                        bloodPressureDatasummary2.bp3 +
                                                                                        bloodPressureDatasummary2.bp4 +
                                                                                        bloodPressureDatasummary2.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="HIGH STAGE 1<" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(230, 150, 95, 1)" }}>
                                                                        {bloodPressureDatasummary2.bp4} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary2.bp4 /
                                                                                    (bloodPressureDatasummary2.bp1 +
                                                                                        bloodPressureDatasummary2.bp2 +
                                                                                        bloodPressureDatasummary2.bp3 +
                                                                                        bloodPressureDatasummary2.bp4 +
                                                                                        bloodPressureDatasummary2.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="HIGH STAGE 2" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(213, 92, 92, 1)" }}>
                                                                        {bloodPressureDatasummary2.bp5} คน
                                                                        <div> (
                                                                            {(
                                                                                (bloodPressureDatasummary2.bp5 /
                                                                                    (bloodPressureDatasummary2.bp1 +
                                                                                        bloodPressureDatasummary2.bp2 +
                                                                                        bloodPressureDatasummary2.bp3 +
                                                                                        bloodPressureDatasummary2.bp4 +
                                                                                        bloodPressureDatasummary2.bp5)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>

                                                                </tr>



                                                            </tbody>
                                                        </table> </div>

                                                </div>







                                            )}
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        // )

                        //     : null
                    }
                </div>

            </div>
        </div>





    );
};

export default BloodPressureChartComponent;
